const KEY = "studz:lastLeagueId";

// Session-only (not persisted across browser sessions) so the header's league
// tabs keep pointing at the right league while navigating between the
// now-separate /leagues/[id]/{team,players,teams,history} pages.
export function getStoredLeagueId(): string | null {
  if (typeof window === "undefined") return null;
  return sessionStorage.getItem(KEY);
}

export function setStoredLeagueId(id: string) {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(KEY, id);
}
